"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var od_icon_1 = __importDefault(require("@tencent/od-icon"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var Tag = function Tag(props, ref) {
  var _a;
  var label = props.label,
    children = props.children,
    _b = props.type,
    type = _b === void 0 ? 'info' : _b,
    _c = props.size,
    size = _c === void 0 ? 'mini' : _c,
    prefix = props.prefix,
    suffix = props.suffix,
    _d = props.radius,
    radius = _d === void 0 ? '4' : _d,
    lineHeight = props.lineHeight,
    style = props.style,
    _e = props.as,
    as = _e === void 0 ? 'span' : _e,
    _f = props.inlineBlock,
    inlineBlock = _f === void 0 ? true : _f,
    _g = props.block,
    block = _g === void 0 ? false : _g,
    _h = props.bordered,
    bordered = _h === void 0 ? true : _h,
    _j = props.closable,
    closable = _j === void 0 ? false : _j,
    _k = props.defaultShowClose,
    defaultShowClose = _k === void 0 ? false : _k,
    padding = props.padding,
    className = props.className,
    textClassName = props.textClassName,
    _l = props.prefixCls,
    prefixCls = _l === void 0 ? '' : _l,
    onClose = props.onClose,
    _m = props.useCSSZoom,
    useCSSZoom = _m === void 0 ? false : _m,
    restProps = __rest(props, ["label", "children", "type", "size", "prefix", "suffix", "radius", "lineHeight", "style", "as", "inlineBlock", "block", "bordered", "closable", "defaultShowClose", "padding", "className", "textClassName", "prefixCls", "onClose", "useCSSZoom"]);
  var p = padding || (size !== 'mini' ? '0-4' : '0-2');
  var isMini = size === 'mini';
  var miniClass = !useCSSZoom ? 'odc-text-mini' : 'odc-zoom-text-mini';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var handlerClose = (0, react_1.useCallback)(function (e) {
    e.stopPropagation();
    if (!onClose) return;
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])("".concat(prefixCls, "odc-tag"), "".concat(prefixCls, "odc-tag-").concat(size), type, !bordered && 'odc-tag-no-shadow', {
      'has-close': !!onClose || closable,
      'default-show-close': defaultShowClose
    }),
    supportAllEvents: true,
    ref: ref
  }, Tag), {
    radius: radius,
    as: as,
    inlineBlock: block ? false : inlineBlock,
    block: block,
    padding: p,
    style: __assign({
      lineHeight: lineHeight
    }, style)
  }), react_1["default"].createElement("div", {
    className: 'odc-tag-content'
  }, prefix, react_1["default"].createElement("span", {
    className: (0, classnames_1["default"])('odc-tag-text', isMini ? miniClass : '', textClassName, (_a = {}, _a["".concat(prefixCls, "odc-text-").concat(size)] = !isMini, _a))
  }, label || children), suffix), (closable || onClose) && react_1["default"].createElement("div", {
    className: 'odc-tag-close',
    onClick: handlerClose
  }, react_1["default"].createElement(od_icon_1["default"], {
    className: 'odc-tag-close-icon',
    name: 'close-bold-outlined'
  })));
};
(0, spaui_utils_1.setComponentMark)(Tag, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Tag));